import React, { useEffect, useRef, useState } from 'react';

export default function ParityDialog({ title, children, onClose, onSubmit, submitLabel = 'ثبت', disabled = false, submitDisabled = false, className = '' }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const previous = document.activeElement;
    ref.current?.querySelector('input,select,textarea,button')?.focus();
    return () => previous?.focus?.();
  }, []);
  const submit = async e => {
    e.preventDefault(); if (busy || disabled || submitDisabled) return;
    setBusy(true); setError('');
    try { await onSubmit(new FormData(e.currentTarget)); onClose(); }
    catch (err) { setError(err?.response?.data?.error?.message || err?.response?.data?.message || err.message || 'ثبت ناموفق بود.'); }
    finally { setBusy(false); }
  };
  return <div className="parity-dialog-backdrop" onMouseDown={e => { if (e.target === e.currentTarget && !busy) onClose(); }}>
    <section ref={ref} className={`parity-dialog${className ? ` ${className}` : ''}`} role="dialog" aria-modal="true" aria-label={title} onKeyDown={e => {
      if (e.key === 'Escape' && !busy) onClose();
      if (e.key === 'Tab') {
        const items = [...ref.current.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href]')];
        const first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
      }
    }}>
      <header><h2>{title}</h2><button type="button" aria-label="بستن" disabled={busy} onClick={onClose}>×</button></header>
      <form onSubmit={submit}><fieldset disabled={busy || disabled}>{children}</fieldset>
        {error && <p role="alert">{error}</p>}
        <footer><button type="button" className="mis-button is-secondary" disabled={busy} onClick={onClose}>انصراف</button>{onSubmit && <button type="submit" className="mis-button" disabled={busy || disabled || submitDisabled}>{busy ? 'در حال ثبت…' : submitLabel}</button>}</footer>
      </form>
    </section>
  </div>;
}
